module.exports = __webpack_public_path__ + "img/icon_profil_white.f134e1a2.svg";